import { z } from 'zod';
import { PrismaEnums } from '@airreading/schema/browser';

export const backgroundCheckStatusSchema = z.enum([
  'checkr_passed',
  'ebr_fingerprint_passed',
  'ebr_fingerprint_processing',
  'ebr_fingerprint_pending_or_passed',
  'ebr_fingerprint_quality_reject',
  'california_fingerprint_passed',
  'florida_fingerprint_passed',
  'florida_fingerprint_processing',
  'florida_fingerprint_pending_or_passed',
  'florida_foundations_course_completed',
  'uva_cleared',
  'uva_fingerprint_processing',
  'uva_fingerprint_pending_or_cleared',
  'louisiana_can',
]);

export const techCheckTypeSchema = z.enum(['zoomTechCheck', 'googleMeetTechCheck']);

export const teachingPreferenceSchema = z.nativeEnum(PrismaEnums.TeachingPreference);
export type TeachingPreference = z.infer<typeof teachingPreferenceSchema>;
export const TeachingPreference = teachingPreferenceSchema.enum;
export const TeachingPreferenceLabelMap: Record<TeachingPreference, string> = {
  [TeachingPreference.regular_schedule]: 'Regular schedule',
  [TeachingPreference.substitute_teaching]: 'Substitute teaching',
};

/** Teachers cannot edit their display name, so it does not count toward the basic info they must complete. */
export function isCoachBasicInfoCompleted(input: {
  firstName: string | null;
  lastName: string | null;
  phone: string | null;
  timeZone: string | null;
}): boolean {
  return [input.firstName, input.lastName, input.phone, input.timeZone].every(
    (value) => typeof value === 'string' && value.trim().length > 0,
  );
}

export function defaultCoachDisplayName(firstName: string | null | undefined): string | null {
  const trimmedFirstName = firstName?.trim();
  return trimmedFirstName ? `Teacher ${trimmedFirstName}` : null;
}

/** Display name for a newly created teacher profile: the provided one, else `Teacher <first name>`. */
export function newCoachDisplayName(
  displayName: string | null | undefined,
  firstName: string | null | undefined,
): string | null {
  return displayName?.trim() || defaultCoachDisplayName(firstName);
}
